import { render } from "./BangladeshPage.vue?vue&type=template&id=a16c3d38&scoped=true"
import script from "./BangladeshPage.vue?vue&type=script&lang=js"
export * from "./BangladeshPage.vue?vue&type=script&lang=js"

import "./BangladeshPage.vue?vue&type=style&index=0&id=a16c3d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a16c3d38"]])

export default __exports__